/**
 * Auto-generated polygon outlines for Spine attachment regions.
 * Points are [x, y] pairs in pixels relative to the attachment's top-left.
 * (0,0) = top-left of the original un-trimmed attachment rect.
 *
 * To regenerate:
 *   npm run scripts:compile
 *   node scripts/ts/trace-spine-regions.js
 */

export interface AttachmentPolygon {
  points: [number, number][];
  width: number;
  height: number;
}

const polygons: Record<string, AttachmentPolygon> = {
  "Images/Arm8_1": {
    width: 22,
    height: 8,
    points: [[0,0],[6,0],[7,4],[2,7]]
  },
  "Images/Arm8_2": {
    width: 23,
    height: 7,
    points: [[1,0],[5,0],[6,4],[4,6],[0,4]]
  },
  "Images/Arm8_3": {
    width: 20,
    height: 5,
    points: [[0,0],[4,1],[1,4]]
  },
  "Images/Bottom_body_2": {
    width: 67,
    height: 64,
    points: [[38,0],[47,2],[52,10],[64,11],[66,23],[65,38],[61,50],[48,61],[40,63],[25,62],[17,59],[9,51],[2,37],[0,27],[18,10]]
  },
  "Images/Bottom_body_3": {
    width: 69,
    height: 66,
    points: [[41,0],[63,2],[68,14],[67,31],[60,45],[42,63],[28,65],[19,62],[4,42],[0,31],[0,16],[21,5]]
  },
  "Images/Bottom_body_Cannon_2front": {
    width: 67,
    height: 64,
    points: [[65,0],[65,20],[61,32],[45,44],[25,44],[25,40],[33,34],[36,23],[41,18],[52,13]]
  },
  "Images/Bottom_body_cannon_11": {
    width: 43,
    height: 45,
    points: [[9,1],[32,1],[40,11],[42,26],[26,42],[24,30],[15,20],[9,18],[1,20],[3,9]]
  },
  "Images/Bottom_body_cannon_3back": {
    width: 69,
    height: 66,
    points: [[41,0],[59,1],[64,5],[67,15],[67,28],[61,43],[41,63],[28,65],[19,62],[4,42],[0,31],[0,16],[21,5]]
  },
  "Images/Bottom_body_cannon_3front": {
    width: 69,
    height: 66,
    points: [[37,0],[54,0],[53,12],[42,24],[40,34],[34,22]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_000": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[5,24],[0,19],[0,12],[4,8],[41,5]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_001": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[25,23],[22,19],[24,9],[41,5]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_002": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[29,23],[26,19],[28,9]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_003": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[35,26],[28,19],[30,9]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_004": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[27,23],[24,19],[26,9],[41,5]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_005": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[25,23],[22,19],[24,9],[41,5]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_006": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[64,31],[58,34],[51,34],[41,27],[22,24],[18,21],[17,12],[19,9],[41,5]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_007": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[64,31],[58,34],[51,34],[41,27],[16,24],[12,21],[11,12],[13,9],[41,5]]
  },
  "Images/Cannons/Big cannon shoot/Cannon_shoot_big_008": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[5,24],[0,19],[0,12],[4,8],[41,5]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_000": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[45,31],[37,23],[36,12],[38,8]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_001": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[45,31],[37,23],[36,12],[38,8]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_002": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[45,31],[37,23],[36,12],[38,8]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_003": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[45,31],[41,27],[36,26],[31,20],[32,10]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_004": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[28,27],[21,20],[21,12],[26,6],[41,5]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_005": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[64,31],[58,34],[51,34],[41,27],[26,27],[20,22],[19,12],[24,6],[41,5]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_006": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[64,31],[58,34],[51,34],[41,27],[26,27],[12,21],[11,12],[13,9],[22,8],[26,5],[41,5]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_007": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[7,24],[2,19],[2,12],[6,8],[41,5]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_008": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[5,24],[0,19],[0,12],[4,8],[41,5]]
  },
  "Images/Cannons/Big cannon/Cannon_out_big_009": {
    width: 74,
    height: 35,
    points: [[49,0],[62,1],[73,12],[73,17],[68,27],[58,34],[51,34],[41,27],[5,24],[0,19],[0,12],[4,8],[41,5]]
  },
  "Images/Cannons/Small cannon shoot/Cannon_small_shoot_000": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[18,27],[2,27],[0,25],[2,20],[18,20],[20,18],[18,14],[2,14],[0,12],[2,7],[18,7]]
  },
  "Images/Cannons/Small cannon shoot/Cannon_small_shoot_001": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[19,27],[4,27],[2,25],[4,20],[20,19],[19,14],[4,14],[2,9],[4,7],[19,7]]
  },
  "Images/Cannons/Small cannon shoot/Cannon_small_shoot_002": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[19,27],[5,27],[3,25],[5,20],[20,19],[19,14],[5,14],[3,9],[5,7],[19,7]]
  },
  "Images/Cannons/Small cannon/Cannon_small_000": {
    width: 48,
    height: 37,
    points: [[33,9],[39,10],[45,19],[41,26],[31,28],[23,23],[22,17],[25,12]]
  },
  "Images/Cannons/Small cannon/Cannon_small_001": {
    width: 48,
    height: 37,
    points: [[32,8],[37,8],[44,14],[45,19],[41,26],[30,28],[22,23],[21,16],[23,12]]
  },
  "Images/Cannons/Small cannon/Cannon_small_002": {
    width: 48,
    height: 37,
    points: [[32,7],[37,7],[45,13],[46,18],[42,26],[30,28],[21,23],[20,16],[22,11]]
  },
  "Images/Cannons/Small cannon/Cannon_small_003": {
    width: 48,
    height: 37,
    points: [[19,7],[23,7],[21,9]]
  },
  "Images/Cannons/Small cannon/Cannon_small_004": {
    width: 48,
    height: 37,
    points: [[32,7],[40,8],[46,14],[47,19],[42,28],[28,30],[21,26],[19,18],[23,10]]
  },
  "Images/Cannons/Small cannon/Cannon_small_005": {
    width: 48,
    height: 37,
    points: [[32,7],[40,8],[46,14],[47,19],[42,28],[28,30],[21,26],[19,18],[23,10]]
  },
  "Images/Cannons/Small cannon/Cannon_small_006": {
    width: 48,
    height: 37,
    points: [[27,7],[38,7],[46,14],[47,21],[40,29],[29,29],[21,24],[21,12]]
  },
  "Images/Cannons/Small cannon/Cannon_small_007": {
    width: 48,
    height: 37,
    points: [[29,8],[39,11],[44,15],[44,28],[37,33],[26,30],[19,21],[20,14]]
  },
  "Images/Cannons/Small cannon/Cannon_small_008": {
    width: 48,
    height: 37,
    points: [[28,6],[36,7],[44,15],[44,26],[38,32],[29,32],[20,21],[21,12]]
  },
  "Images/Cannons/Small cannon/Cannon_small_009": {
    width: 48,
    height: 37,
    points: [[24,5],[42,6],[43,18],[38,26],[29,27],[22,22],[21,9]]
  },
  "Images/Cannons/Small cannon/Cannon_small_010": {
    width: 48,
    height: 37,
    points: [[24,5],[42,6],[43,18],[38,26],[29,27],[22,22],[21,9]]
  },
  "Images/Cannons/Small cannon/Cannon_small_011": {
    width: 48,
    height: 37,
    points: [[27,5],[39,6],[44,12],[44,23],[35,32],[26,31],[20,23],[21,11]]
  },
  "Images/Cannons/Small cannon/Cannon_small_012": {
    width: 48,
    height: 37,
    points: [[27,5],[39,5],[44,10],[45,23],[41,29],[28,30],[21,25],[20,12]]
  },
  "Images/Cannons/Small cannon/Cannon_small_013": {
    width: 48,
    height: 37,
    points: [[25,4],[41,4],[43,6],[45,22],[41,28],[28,29],[21,24],[20,11]]
  },
  "Images/Cannons/Small cannon/Cannon_small_014": {
    width: 48,
    height: 37,
    points: [[26,2],[40,3],[45,9],[44,26],[34,35],[27,34],[21,27],[20,9]]
  },
  "Images/Cannons/Small cannon/Cannon_small_015": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[21,28],[20,7]]
  },
  "Images/Cannons/Small cannon/Cannon_small_016": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[21,28],[20,7]]
  },
  "Images/Cannons/Small cannon/Cannon_small_017": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[21,28],[20,7]]
  },
  "Images/Cannons/Small cannon/Cannon_small_018": {
    width: 48,
    height: 37,
    points: [[21,0],[44,0],[45,18],[41,24],[28,25],[21,20]]
  },
  "Images/Cannons/Small cannon/Cannon_small_019": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[20,25],[20,7]]
  },
  "Images/Cannons/Small cannon/Cannon_small_020": {
    width: 48,
    height: 37,
    points: [[19,0],[44,0],[43,12],[45,18],[39,26],[26,27],[19,22]]
  },
  "Images/Cannons/Small cannon/Cannon_small_021": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[17,25],[20,18],[17,9]]
  },
  "Images/Cannons/Small cannon/Cannon_small_022": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[17,25],[20,18],[17,9]]
  },
  "Images/Cannons/Small cannon/Cannon_small_023": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[17,25],[20,18],[17,9]]
  },
  "Images/Cannons/Small cannon/Cannon_small_024": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[16,25],[20,18],[16,9]]
  },
  "Images/Cannons/Small cannon/Cannon_small_025": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[18,27],[10,25],[12,20],[20,18],[18,14],[12,14],[10,9],[18,7]]
  },
  "Images/Cannons/Small cannon/Cannon_small_026": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[18,27],[5,27],[3,25],[5,20],[18,20],[20,18],[18,14],[5,14],[3,9],[5,7],[18,7]]
  },
  "Images/Cannons/Small cannon/Cannon_small_027": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[18,27],[3,27],[1,25],[3,20],[18,20],[20,18],[18,14],[3,14],[1,9],[3,7],[18,7]]
  },
  "Images/Cannons/Small cannon/Cannon_small_028": {
    width: 48,
    height: 37,
    points: [[26,0],[40,1],[45,7],[44,27],[34,36],[27,35],[18,27],[2,27],[0,25],[2,20],[18,20],[20,18],[18,14],[2,14],[0,12],[2,7],[18,7]]
  },
  "Images/Eye_big": {
    width: 6,
    height: 11,
    points: [[2,0],[5,4],[3,10],[0,8]]
  },
  "Images/Eyes_sockets": {
    width: 26,
    height: 26,
    points: [[10,0],[15,0],[18,4],[23,5],[21,9],[25,16],[19,18],[12,25],[6,25],[2,22],[3,19],[0,12],[3,3]]
  },
  "Images/Eyes_sockets_bottom": {
    width: 20,
    height: 11,
    points: [[0,0],[10,0],[5,10],[1,7]]
  },
  "Images/Gear": {
    width: 15,
    height: 13,
    points: [[4,0],[10,0],[14,4],[14,8],[10,12],[4,12],[0,8],[0,4]]
  },
  "Images/Inner_canon": {
    width: 38,
    height: 35,
    points: [[13,0],[24,0],[30,3],[37,12],[37,17],[32,27],[22,34],[14,34],[8,31],[0,18],[2,8]]
  },
  "Images/Inner_canon1": {
    width: 38,
    height: 35,
    points: [[13,0],[23,0],[31,4],[37,12],[37,17],[32,27],[22,34],[15,34],[9,31],[1,23],[0,12],[2,8]]
  },
  "Images/Leg1_1": {
    width: 43,
    height: 9,
    points: [[0,0],[5,0],[6,6],[4,8],[1,6]]
  },
  "Images/Leg1_2": {
    width: 54,
    height: 13,
    points: [[4,0],[8,0],[6,12],[4,11]]
  },
  "Images/Leg1_3": {
    width: 39,
    height: 9,
    points: [[1,0],[8,0],[4,8],[0,7]]
  },
  "Images/Leg_1": {
    width: 43,
    height: 9,
    points: [[3,0],[8,0],[5,8],[2,6]]
  },
  "Images/Leg_2": {
    width: 54,
    height: 13,
    points: [[4,0],[8,0],[7,12],[5,11]]
  },
  "Images/Leg_3": {
    width: 39,
    height: 9,
    points: [[0,0],[7,0],[8,7],[4,8]]
  },
  "Images/Neck": {
    width: 23,
    height: 17,
    points: [[0,0],[16,1],[16,10],[11,16],[7,16],[1,10]]
  },
  "Images/Upper_body_1": {
    width: 44,
    height: 40,
    points: [[17,0],[27,1],[35,8],[43,25],[41,33],[24,39],[18,39],[1,27],[0,20],[5,6],[9,2]]
  },
  "Images/Upper_body_2": {
    width: 68,
    height: 56,
    points: [[26,0],[40,0],[50,4],[62,16],[67,33],[55,45],[42,52],[18,55],[8,52],[3,47],[0,27],[6,16],[19,3]]
  },
  "Images/Upper_body_3": {
    width: 63,
    height: 44,
    points: [[28,0],[36,0],[49,5],[61,15],[61,26],[49,42],[21,42],[1,32],[1,18],[6,7]]
  },
  "Images/Upper_body_cannon_1": {
    width: 44,
    height: 40,
    points: [[17,0],[27,1],[35,8],[43,25],[41,33],[20,39],[14,28],[7,21],[1,19],[5,6],[9,2]]
  },
  "Images/Upper_body_cannon_1_back": {
    width: 44,
    height: 40,
    points: [[16,0],[28,1],[34,7],[41,23],[40,29],[18,37],[1,25],[0,18],[4,16],[6,6],[11,1]]
  },
  "Images/Upper_body_cannon_2": {
    width: 68,
    height: 56,
    points: [[26,3],[40,3],[50,7],[62,19],[65,25],[67,36],[55,48],[42,55],[38,54],[38,49],[32,35],[24,25],[13,22],[1,27],[19,6]]
  },
  "Images/Upper_body_cannon_2_back": {
    width: 68,
    height: 56,
    points: [[21,0],[53,0],[32,9],[29,9]]
  },
  "Images/Upper_body_cannon_3": {
    width: 63,
    height: 44,
    points: [[28,5],[36,5],[49,10],[61,20],[61,31],[51,43],[48,42],[42,27],[32,17],[13,9]]
  },
  "Images/Upper_body_cannon_3_back": {
    width: 63,
    height: 44,
    points: [[23,0],[40,1],[51,6],[60,15],[59,24],[48,40],[21,40],[1,30],[1,16],[6,5]]
  },
  "Images/Wires_head": {
    width: 35,
    height: 34,
    points: [[3,0],[13,4],[21,1],[26,2],[30,6],[34,17],[33,24],[24,32],[19,33],[24,29],[22,28],[26,21],[20,15],[14,23],[6,25],[13,21],[14,16],[10,13],[11,6],[8,8],[5,2],[0,3]]
  },
  "Images/base_head": {
    width: 34,
    height: 19,
    points: [[33,0],[30,11],[19,18],[12,18],[6,15],[0,7],[0,4],[5,10],[12,11],[20,4]]
  },
  "Images/base_head_bottom": {
    width: 34,
    height: 18,
    points: [[21,0],[33,2],[31,9],[25,15],[7,17],[1,12],[0,8],[3,4]]
  },
  "Images/modem1_bottom": {
    width: 16,
    height: 16,
    points: [[10,0],[15,2],[13,13],[0,15],[2,11],[1,3]]
  },
  "Images/modem1_midle": {
    width: 20,
    height: 18,
    points: [[9,0],[12,0],[17,8],[6,17],[0,8]]
  },
  "Images/modem1_up": {
    width: 16,
    height: 17,
    points: [[6,1],[15,1],[15,10],[12,15],[1,16],[0,12]]
  },
  "Images/modem2_bottom": {
    width: 23,
    height: 17,
    points: [[1,0],[15,0],[16,8],[4,16],[1,15]]
  },
  "Images/modem2_up": {
    width: 24,
    height: 15,
    points: [[10,0],[23,1],[23,5],[14,14],[0,13],[0,9]]
  },
  "Images/modem3_bottom": {
    width: 28,
    height: 15,
    points: [[1,0],[13,0],[14,5],[6,14],[1,14],[0,12]]
  },
  "Images/modem3_midle": {
    width: 17,
    height: 18,
    points: [[9,0],[12,1],[16,9],[5,17],[0,5]]
  },
  "Images/modem3_up": {
    width: 23,
    height: 9,
    points: [[7,0],[17,0],[22,3],[22,6],[8,8],[0,5],[0,2]]
  },
};

export default polygons;
